<template lang="pug">
div(v-if="pessoa")
  el-row.pad5
    el-col(:span="12")
      p
        span.label CPF:
        span &nbsp {{filterNull(pessoa.cpf)}}
    el-col(:span="12")
      p
        span.label Nome:
        span &nbsp {{filterNull(pessoa.nome)}}
    el-col(:span="12")
      p
        span.label Apelido:
        span &nbsp {{filterNull(pessoa.apelido)}}

    el-col(:span="12")
      p
        span.label RG:
        span &nbsp {{filterNull(pessoa.rg)}}
    el-col(:span="12")
      p
        span.label Órgão expedidor:
        span &nbsp {{getNameOrgaoExpedidor(pessoa.orgaoExpedidor.codigo)}}
    el-col(:span="12")
      p
        span.label UF do RG:
        span &nbsp {{getUfRg(pessoa) || '-'}}
    el-col(:span="12")
      p
        span.label Nacionalidade:
        span &nbsp {{nomeGentilico}}
    el-col(:span="12", v-if="isBrasileiro")
      p
        span.label UF da naturalidade:
        span &nbsp {{filterNull(municipio.codigoEstado)}}
    el-col(:span="12", v-if="isBrasileiro")
      p
        span.label Município da naturalidade:
        span &nbsp {{filterNull(municipio.nome)}}
    el-col(:span="12")
      p
        span.label Data de nascimento:
        span &nbsp {{filterNullDate(pessoa.dataNascimento)}}
  slot
</template>
<script>

import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import gentilicos from '@/constants/gentilico'

export default {

  props: {
    pessoa: {
      Type: Object,
      required: true
    },
    isCadastro: {
      Type: Boolean,
      default: false
    },
    isProcessoFisicoConjuge: {
      Type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return {
      municipio: {}
    }
  },

  created () {
    this.findMunicipioById()
  },

  activated () {
    this.findMunicipioById()
  },

  computed: {

    nomeGentilico () {
      if (_.isEmpty(gentilicos)) {
        return '-'
      }
      if (this.pessoa.nacionalidade === 'brasil') {
        return 'Brasileiro(a)'
      }
      return _.find(gentilicos,
        gentilico => gentilico.sigla === this.pessoa.nacionalidade).gentilico
    },

    isBrasileiro () {
      return this.pessoa.nacionalidade === 'BR'
    }

  },
  methods: {
    ...mapActions({
      getMunicipioById: 'municipios/findMunicipioById'
    }),

    getUfRg (pessoa) {
      return pessoa.orgaoExpedidor.estado ? pessoa.orgaoExpedidor.estado : pessoa.codigo !== null ? pessoa.codigo : '-'
    },

    async findMunicipioById () {
      try {
        const municipioId = this.pessoa?.naturalidade?.municipio?.id
        if (municipioId) {
          this.municipio = await this.getMunicipioById(municipioId)
        }
      } catch (error) {
        this.municipio = '-'
      }
    },

    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    },
    filterNullDate (atributo) {
      return !atributo ? '-' : moment(this.pessoa.dataNascimento).format('DD/MM/YYYY') //eslint-disable-line
    },
    getNameOrgaoExpedidor (codigo) {
      switch (codigo) {
        case 'PC':
          return 'PC - Polícia Civil'
        case 'PF':
          return 'POF - Polícia Federal'
        case 'PM':
          return 'PM - Polícia Militar'
        case 'SSP':
          return 'SSP - Secretaria de Segurança Pública'
        default:
          return 'Ourtos'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}
@media (max-width: 780px) {
  .pad5 {
    display: flex;
    flex-direction: column;
    width: 460px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoPessoaFisica.vue